<div fxLayout="column" fxLayoutGap="20px">
  <app-page-header title="Inscrições">
    <app-export-button (export)="exportar()"></app-export-button>
  </app-page-header>

  <!-- Seção de Heteroidentificação para PTPP -->
  <mat-card *ngIf="isPTPP" class="card-heteroidentificacao">
    <mat-card-header class="hetero-header">
      <div class="header-content">
        <div class="header-left">
          <mat-icon class="header-icon">verified_user</mat-icon>
          <div class="header-text">
            <mat-card-title>Processo de Heteroidentificação</mat-card-title>
            <mat-card-subtitle>Integração com sistema externo de heteroidentificação</mat-card-subtitle>
          </div>
        </div>
        <div class="header-right" *ngIf="temDadosHetero()">
          <div class="info-box">
            <div class="info-item-inline">
              <mat-icon class="info-icon">folder_open</mat-icon>
              <div class="info-content">
                <span class="info-label">Processo de Heteroidentificação:</span>
                <span class="info-value">{{ concursoProcessoHetero }}</span>
              </div>
            </div>
            <div class="info-item-inline">
              <mat-icon class="info-icon">description</mat-icon>
              <div class="info-content">
                <span class="info-label">Edital:</span>
                <span class="info-value">{{ concursoEditalHetero }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-header>

    <mat-card-content>
      <div class="hetero-content">
        <!-- Stepper de Progresso -->
        <div class="stepper-section">
          <div class="stepper-container">
            <!-- Step 1: Sincronização -->
            <div class="step" [ngClass]="getStepClass(1)">
              <div class="step-icon">
                <mat-icon *ngIf="temDadosHetero()">check_circle</mat-icon>
                <mat-icon *ngIf="!temDadosHetero()">sync_problem</mat-icon>
              </div>
              <div class="step-content">
                <div class="step-title">Sincronização</div>
                <div class="step-description">
                  {{ temDadosHetero() ? 'Sincronizado' : 'Não Sincronizado' }}
                </div>
                <button 
                  mat-flat-button 
                  color="primary"
                  class="step-action-button"
                  (click)="buscarIdentificador()"
                  [disabled]="algumCandidatoEnviado()"
                  [class.pulse-animation]="!temDadosHetero() && !algumCandidatoEnviado()"
                  [matTooltip]="getTooltipSincronizar()"
                  matTooltipPosition="below">
                  <mat-icon>{{ temDadosHetero() ? 'sync' : 'link' }}</mat-icon>
                  {{ temDadosHetero() ? 'Ressincronizar' : 'Sincronizar' }}
                </button>
              </div>
            </div>

            <div class="step-connector" [ngClass]="temDadosHetero() ? 'completed' : ''"></div>

            <!-- Step 2: Candidatos Enviados -->
            <div class="step" [ngClass]="getStepClass(2)">
              <div class="step-icon">
                <mat-icon *ngIf="getStatusCandidatosEnviados() === 'completo'">check_circle</mat-icon>
                <mat-icon *ngIf="getStatusCandidatosEnviados() === 'parcial'">pending</mat-icon>
                <mat-icon *ngIf="getStatusCandidatosEnviados() === 'pendente'">radio_button_unchecked</mat-icon>
              </div>
              <div class="step-content">
                <div class="step-title">Candidatos Enviados</div>
                <div class="step-description">
                  {{ getDescricaoCandidatosEnviados() }}
                </div>
                <button 
                  mat-stroked-button 
                  color="primary"
                  class="step-action-button"
                  [disabled]="!podeEnviarCandidatos()"
                  (click)="enviarCandidatos()"
                  [matTooltip]="getTooltipEnviarCandidatos()"
                  matTooltipPosition="below">
                  <mat-icon>send</mat-icon>
                  Enviar Candidatos
                </button>
              </div>
            </div>

            <div class="step-connector" [ngClass]="getStatusCandidatosEnviados() === 'completo' ? 'completed' : ''"></div>

            <!-- Step 3: Fotos Enviadas -->
            <div class="step" [ngClass]="getStepClass(3)">
              <div class="step-icon">
                <mat-icon *ngIf="getStatusFotosEnviadas() === 'completo'">check_circle</mat-icon>
                <mat-icon *ngIf="getStatusFotosEnviadas() === 'parcial'">pending</mat-icon>
                <mat-icon *ngIf="getStatusFotosEnviadas() === 'pendente'">radio_button_unchecked</mat-icon>
              </div>
              <div class="step-content">
                <div class="step-title">Fotos Enviadas</div>
                <div class="step-description">
                  {{ getDescricaoFotosEnviadas() }}
                </div>
                <button 
                  mat-stroked-button 
                  color="primary"
                  class="step-action-button"
                  [disabled]="!podeEnviarFotos()"
                  (click)="enviarCandidatos()"
                  [matTooltip]="getTooltipEnviarFotos()"
                  matTooltipPosition="below">
                  <mat-icon>photo_camera</mat-icon>
                  Enviar Fotos
                </button>
              </div>
            </div>

            <div class="step-connector" [ngClass]="getStatusFotosEnviadas() === 'completo' ? 'completed' : ''"></div>

            <!-- Step 4: Resultados -->
            <div class="step" [ngClass]="getStepClass(4)">
              <div class="step-icon">
                <mat-icon *ngIf="getStatusResultados() === 'completo'">check_circle</mat-icon>
                <mat-icon *ngIf="getStatusResultados() === 'parcial'">pending</mat-icon>
                <mat-icon *ngIf="getStatusResultados() === 'pendente'">radio_button_unchecked</mat-icon>
              </div>
              <div class="step-content">
                <div class="step-title">Resultados</div>
                <div class="step-description">
                  {{ getDescricaoResultados() }}
                </div>
                <button 
                  mat-stroked-button 
                  color="primary"
                  class="step-action-button"
                  [disabled]="!podeBuscarResultados()"
                  (click)="buscarResultados()"
                  [matTooltip]="getTooltipBuscarResultados()"
                  matTooltipPosition="below">
                  <mat-icon>download</mat-icon>
                  Buscar Resultados
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Alerta de Não Sincronizado -->
        <div class="alerta-section" *ngIf="!temDadosHetero()">
          <div class="alerta-content">
            <mat-icon class="alerta-icon">info</mat-icon>
            <div class="alerta-text">
              <strong>Atenção:</strong> O concurso ainda não foi sincronizado com o Sistema de Heteroidentificação.
              Clique no botão "Sincronizar" acima para habilitar as funcionalidades de envio e busca de resultados.
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <div fxLayout.lt-md="column" fxLayoutGap="20px">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Situação</mat-label>
      <mat-select name="filtroSituacao" [(value)]="filtroSituacaoSelecionada" (selectionChange)="getData()">
        <mat-option *ngFor="let enum of tipoSituacao | keyvalue" [value]="enum.key">
          {{ enum.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>

  </div>

  <app-search-input #searchInput></app-search-input>

  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
      </ng-container>
      <ng-container matColumnDef="concurso">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Concurso</th>
        <td mat-cell *matCellDef="let row">
          <p><span [matTooltip]="row.campus">{{ row.siglaUnidade }}</span></p>
          <p><app-ellipsis-tooltip [content]="row.tituloConcurso" [maxLength]="50"></app-ellipsis-tooltip></p>
        </td>
      </ng-container>

      <ng-container matColumnDef="inscricao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Inscrição</th>
        <td mat-cell *matCellDef="let row">
          <p>{{ row.data | date : 'dd/MM/yyyy HH:mm:ss' }}</p>
          <p *ngIf="!isDepartamento"><app-ellipsis-tooltip [content]="row.protocolo" [maxLength]="20"></app-ellipsis-tooltip></p>
        </td>
      </ng-container>

      <ng-container matColumnDef="candidato">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Candidato</th>
        <td mat-cell *matCellDef="let row">
          <p><app-ellipsis-tooltip [content]="row.nomeSocial || row.nome" [maxLength]="30"></app-ellipsis-tooltip></p>
          <p><b>CPF</b> {{ row.cpf }}</p>
          <p><b>RG</b> {{ row.rg }}</p>
        </td>
      </ng-container>

      <ng-container matColumnDef="contato">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Contato</th>
        <td mat-cell *matCellDef="let row">
          <p><app-ellipsis-tooltip [content]="row.email" [maxLength]="30"></app-ellipsis-tooltip></p>
          <p>{{ getCelularMask(row.estrangeiro, row.celular) }}</p>
          <p>{{ getCelularMask(row.estrangeiro, row.telefone) }}</p>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Situação</th>
        <td mat-cell *matCellDef="let row" [ngSwitch]="row">
          <p>{{ row.status | inscricaoSituacao }}</p>
        </td>
      </ng-container>

      <ng-container matColumnDef="pago">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Pago</th>
        <td mat-cell *matCellDef="let row">
          <p>{{ row.valor != 0 ? (row.pago ? 'Sim' : "Não") : "Gratuito" }}</p>
          <p class="red" *ngIf="row.reducao">
            <span *ngIf="!row.reducaoData">Redução Solicitada e Aguardando Análise</span>
            <span *ngIf="row.reducaoData && !row.reducaoAprovado">Redução Não aprovada</span>
            <span *ngIf="row.reducaoData && row.reducaoAprovado">Redução Aprovada</span>
            <span *ngIf="row.reducaoData && !row.reducaoConcluida"> (Não concluída)</span>
          </p>
          <p *ngIf="row.devolucaoSolicitada && !row.devolucaoConcluida">Devolução solicitada</p>
          <p *ngIf="row.devolucaoSolicitada && row.devolucaoConcluida">Devolução concluída</p>
        </td>
      </ng-container>

      <ng-container matColumnDef="statusHeteroidentificacao">
        <th mat-header-cell *matHeaderCellDef>Status de Heteroidentificação</th>
        <td mat-cell *matCellDef="let row">
          <div style="display: flex; align-items: center; gap: 4px;">
            <mat-icon *ngIf="isStatusHeteroidentificacaoSemFoto(row.statusHeteroidentificacao)" 
                      matTooltip="Não foi possível enviar a foto do candidato."
                      style="color: red; font-size: 18px; height: 18px; width: 18px;">warning</mat-icon>
            <mat-icon *ngIf="isStatusHeteroidentificacaoAlerta(row.statusHeteroidentificacao)" 
                      matTooltip="Não foi possível enviar o candidato para heteroidentificação."
                      style="color: red; font-size: 18px; height: 18px; width: 18px;">warning</mat-icon>
            <span [matTooltip]="getStatusHeteroidentificacaoTooltip(row.statusHeteroidentificacao)"
                  [style.color]="isStatusHeteroidentificacaoAlerta(row.statusHeteroidentificacao) 
                  || isStatusHeteroidentificacaoSemFoto(row.statusHeteroidentificacao) ? 'red' : 'inherit'">
              {{ getStatusHeteroidentificacao(row.statusHeteroidentificacao) }}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="outros">
        <th mat-header-cell *matHeaderCellDef>Informações Adicionais</th>
        <td mat-cell *matCellDef="let row">
          <div class="flex-wrap-gap-8">
            <mat-icon *ngIf="row.canhoto" matTooltip="Canhoto">back_hand</mat-icon>
            <img *ngIf="row.lactante" src="assets/icons/unibfsymbolblacktransparent.png" class="status-icon" matTooltip="Lactante" alt="Lactante">
            <img *ngIf="row.atendimentoEspecial" src="assets/icons/hand-heart-icon-18.png" class="status-icon" matTooltip="Necessidade Especial" alt="Necessidade Especial">
            <img *ngIf="row.vagaDeficiente" src="assets/icons/Accessibility_logo.png" class="status-icon" matTooltip="Pessoa com Deficiência" alt="Pessoa com Deficiência">
            <mat-icon *ngIf="row.provaIngles" matTooltip="Prova em Inglês">language</mat-icon>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row; let i = index">
          <button mat-icon-button color="basic" (click)="abrirFicha(row.id)" title="Ficha">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="boleto">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button
            *ngIf="showEmitirBoleto(row)"
            mat-icon-button
            color="warn"
            (click)="emitirPagamento(row, 'BOLETO')"
            title="Emitir boleto">
            <mat-icon>request_quote</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="pix">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button
            *ngIf="showEmitirPix(row)"
            mat-icon-button
            color="primary"
            (click)="emitirPagamento(row, 'PIX')"
            title="Emitir pix">
            <mat-icon>pix</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="getColunasGrid()"></tr>
      <tr mat-row *matRowDef="let row; columns: getColunasGrid()"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="10">
          <app-table-no-data [searchValue]="searchInput?.value"></app-table-no-data>
        </td>
      </tr>
    </table>
    <app-default-paginator #paginator [length]="totalElements"></app-default-paginator>
  </div>
</div>
